/* === Delivery Ace — Learning Content for Module 1 (структура) ===
 *
 * Проза живёт не здесь, а в src/i18n/catalog/content.<lang>.js и адресуется
 * ключами K('...'). Здесь остаются id секций, имена иконок, классы оформления
 * и пути к картинкам — они одинаковы на всех языках.
 */
import { K } from '@/i18n/key';

export const LEARNING_CONTENT = {
  module_1: {
    title: K('learning.module_1.title'),
    subtitle: K('learning.module_1.subtitle'),
    intro:
      K('learning.module_1.intro'),
    sections: [
      {
        id: 'documents',
        icon: 'FileText',
        title: K('learning.module_1.sections.documents.title'),
        image: '/images/learning/learn_documents.jpg',
        color: 'from-orange-500 to-amber-500',
        bgColor: 'bg-orange-50',
        iconColor: 'text-orange-600',
        paragraphs: [
          K('learning.module_1.sections.documents.paragraphs.0'),
        ],
        keyPoints: [
          {
            label: K('learning.module_1.sections.documents.keyPoints.0.label'),
            description: K('learning.module_1.sections.documents.keyPoints.0.description'),
          },
          {
            label: K('learning.module_1.sections.documents.keyPoints.1.label'),
            description: K('learning.module_1.sections.documents.keyPoints.1.description'),
          },
          {
            label: K('learning.module_1.sections.documents.keyPoints.2.label'),
            description: K('learning.module_1.sections.documents.keyPoints.2.description'),
          },
        ],
        tip: K('learning.module_1.sections.documents.tip'),
      },
      {
        id: 'vehicle',
        icon: 'Car',
        title: K('learning.module_1.sections.vehicle.title'),
        image: '/images/learning/learn_vehicle_check.jpg',
        color: 'from-blue-500 to-cyan-500',
        bgColor: 'bg-blue-50',
        iconColor: 'text-blue-600',
        paragraphs: [
          K('learning.module_1.sections.vehicle.paragraphs.0'),
        ],
        keyPoints: [
          {
            label: K('learning.module_1.sections.vehicle.keyPoints.0.label'),
            description: K('learning.module_1.sections.vehicle.keyPoints.0.description'),
          },
          {
            label: K('learning.module_1.sections.vehicle.keyPoints.1.label'),
            description: K('learning.module_1.sections.vehicle.keyPoints.1.description'),
          },
          {
            label: K('learning.module_1.sections.vehicle.keyPoints.2.label'),
            description: K('learning.module_1.sections.vehicle.keyPoints.2.description'),
          },
          {
            label: K('learning.module_1.sections.vehicle.keyPoints.3.label'),
            description: K('learning.module_1.sections.vehicle.keyPoints.3.description'),
          },
        ],
        tip: K('learning.module_1.sections.vehicle.tip'),
      },
      {
        id: 'equipment',
        icon: 'Backpack',
        title: K('learning.module_1.sections.equipment.title'),
        image: '/images/learning/learn_equipment.jpg',
        color: 'from-emerald-500 to-green-500',
        bgColor: 'bg-emerald-50',
        iconColor: 'text-emerald-600',
        paragraphs: [
          K('learning.module_1.sections.equipment.paragraphs.0'),
        ],
        keyPoints: [
          {
            label: K('learning.module_1.sections.equipment.keyPoints.0.label'),
            description: K('learning.module_1.sections.equipment.keyPoints.0.description'),
          },
          {
            label: K('learning.module_1.sections.equipment.keyPoints.1.label'),
            description: K('learning.module_1.sections.equipment.keyPoints.1.description'),
          },
          {
            label: K('learning.module_1.sections.equipment.keyPoints.2.label'),
            description: K('learning.module_1.sections.equipment.keyPoints.2.description'),
          },
          {
            label: K('learning.module_1.sections.equipment.keyPoints.3.label'),
            description: K('learning.module_1.sections.equipment.keyPoints.3.description'),
          },
        ],
        tip: K('learning.module_1.sections.equipment.tip'),
      },
      {
        id: 'app',
        icon: 'Smartphone',
        title: K('learning.module_1.sections.app.title'),
        image: '/images/learning/learn_app_activation.jpg',
        color: 'from-violet-500 to-purple-500',
        bgColor: 'bg-violet-50',
        iconColor: 'text-violet-600',
        paragraphs: [
          K('learning.module_1.sections.app.paragraphs.0'),
        ],
        keyPoints: [
          {
            label: K('learning.module_1.sections.app.keyPoints.0.label'),
            description: K('learning.module_1.sections.app.keyPoints.0.description'),
          },
          {
            label: K('learning.module_1.sections.app.keyPoints.1.label'),
            description: K('learning.module_1.sections.app.keyPoints.1.description'),
          },
          {
            label: K('learning.module_1.sections.app.keyPoints.2.label'),
            description: K('learning.module_1.sections.app.keyPoints.2.description'),
          },
          {
            label: K('learning.module_1.sections.app.keyPoints.3.label'),
            description: K('learning.module_1.sections.app.keyPoints.3.description'),
          },
        ],
        tip: K('learning.module_1.sections.app.tip'),
      },
      {
        id: 'zones',
        icon: 'Map',
        title: K('learning.module_1.sections.zones.title'),
        image: '/images/learning/learn_delivery_zones.jpg',
        color: 'from-rose-500 to-pink-500',
        bgColor: 'bg-rose-50',
        iconColor: 'text-rose-600',
        paragraphs: [
          K('learning.module_1.sections.zones.paragraphs.0'),
        ],
        keyPoints: [
          {
            label: K('learning.module_1.sections.zones.keyPoints.0.label'),
            description: K('learning.module_1.sections.zones.keyPoints.0.description'),
          },
          {
            label: K('learning.module_1.sections.zones.keyPoints.1.label'),
            description: K('learning.module_1.sections.zones.keyPoints.1.description'),
          },
          {
            label: K('learning.module_1.sections.zones.keyPoints.2.label'),
            description: K('learning.module_1.sections.zones.keyPoints.2.description'),
          },
        ],
        tip: K('learning.module_1.sections.zones.tip'),
      },
    ],
  },
};

export const getLearningContent = (moduleId) => LEARNING_CONTENT[moduleId] || null;
